import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { sessionSelector } from '../../../reducers/session';
import { ROUTE_PATH } from '../../../constants';
import ViewHeader from '../../../widgets/ViewHeader';

type Props = {
  title: string;
};

export const ConnectedAccountPageHeader: React.FunctionComponent<Props> = ({
  title: originalTitle,
}) => {
  const customerName = useSelector(sessionSelector.getCustomerName);
  const isMSP = useSelector(sessionSelector.isMSP);

  const title = isMSP ? (
    <>
      {`${originalTitle} for ${customerName ?? ''}`}
      <br />
      <span style={{ fontSize: '14px' }}>
        <Link to={ROUTE_PATH.MSP_DASHBOARD}>Not the right client?</Link>
      </span>
    </>
  ) : (
    originalTitle
  );

  return <ViewHeader title={title} />;
};
